(function () {
  'use strict';

  /* @ngdoc object
   * @name people.list
   * @description
   *
   */
  angular
    .module('events.people.list', [
      'ui.router'
    ]);
}());
